import { gql } from '@apollo/client';

export const GOODS = gql`
  query goods($input: GoodsInput) {
    goods(input: $input) {
      id
      title
      cost
      wholesale_cost
      amount
      eans
      vat
      use_global_discounts
      use_fair_sign
      comment
      is_excise
      category {
        id
        company_id
        title
        show_in_shell
      }
      show_in_shell
      image
      in_combo
      low_stock_notification {
        enabled
        threshold
      }
      highlighted
    }
  }
`;

export const GET_GOODS_MINIMAL = gql`
  query goods($input: GoodsInput) {
    goods(input: $input) {
      id
      title
      amount
    }
  }
`;

export const CREATE_GOOD = gql`
  mutation createGood($input: GoodInput!) {
    createGood(input: $input) {
      id
      title
      amount
      show_in_shell
      eans
      vat
      category {
        id
        company_id
        title
        show_in_shell
      }
      low_stock_notification {
        enabled
        threshold
      }
    }
  }
`;

export const UPDATE_GOOD = gql`
  mutation updateGood($id: Int!, $input: GoodInput!) {
    updateGood(id: $id, input: $input) {
      id
      title
      amount
      show_in_shell
      eans
      vat
      category {
        id
        company_id
        title
        show_in_shell
      }
      low_stock_notification {
        enabled
        threshold
      }
    }
  }
`;

export const UPDATE_GOODS = gql`
  mutation UpdateGoods($ids: [Int!]!, $input: UpdateGoodsInput!) {
    updateGoods(ids: $ids, input: $input)
  }
`;

export const DELETE_GOOD = gql`
  mutation deleteGood($id: Int!) {
    deleteGood(id: $id) {
      id
      title
    }
  }
`;

export const DELETE_GOODS = gql`
  mutation DeleteGoods($ids: [Int!]!) {
    deleteGoods(ids: $ids)
  }
`;

export const EXPORT_GOODS = gql`
  query Query($input: GoodsInput) {
    exportGoods(input: $input)
  }
`;
